import { Component, HostBinding, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})

export class ConfirmDialogComponent {


  @HostBinding('class')
  hostClassBinding = 'pc-dialog';

  danger = false;

  @HostBinding('class.pc-dialog-confirm')
  get regular() {
    return !this.danger;
  }

  @HostBinding('class.pc-dialog-confirm-danger')
  get dangerous() {
    return this.danger;
  }


  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.danger = data.danger;
  }

  onNoClick(obj): void {
    this.dialogRef.close(obj);
  }

}
